import { render, staticRenderFns } from "./BackBottom.vue?vue&type=template&id=556df7b9&"
import script from "./BackBottom.vue?vue&type=script&lang=js&"
export * from "./BackBottom.vue?vue&type=script&lang=js&"
import style0 from "./BackBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports